import FAQContainer from 'components/Page/FAQ/FAQContainer';

export default FAQContainer;
